import { render } from "./SpinnerComponent.vue?vue&type=template&id=4d8daf50&scoped=true"
import script from "./SpinnerComponent.vue?vue&type=script&lang=js"
export * from "./SpinnerComponent.vue?vue&type=script&lang=js"

import "./SpinnerComponent.vue?vue&type=style&index=0&id=4d8daf50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8daf50"]])

export default __exports__